import './Spinner.css';

/**
 * Inline loading indicator: the Violerts signal-arcs spinner (public/violerts-spinner.svg).
 * Served from public/ as an <img> so the build keeps its internal CSS animation; the SVG
 * carries its own reduced-motion fallback.
 *
 * Keeps the `spinner-border` class so existing tests and callers that look for it still
 * work; Spinner.css switches off Bootstrap's ring styling for it.
 *
 * @param {string} text Optional message under the spinner
 * @param {'sm'|'md'|'lg'|'xl'} size Defaults to 20px
 * @param {string} color Legacy prop, no longer changes the icon's colors
 * @param {string} className Extra classes on the container
 */
function Spinner({ text, size, color, className }) {
	const allowedSizes = ['sm', 'md', 'lg', 'xl'];
	const spinnerSizeClass = allowedSizes.includes(size) ? `spinner-${size}` : '';

	return (
		<div className={`spinner-container ${className ? className : ''}`}>
			<div className="spinner-wrapper" role="status" aria-live="polite">
				<img
					className={`spinner-border vio-spinner ${spinnerSizeClass}`}
					src="/violerts-spinner.svg"
					alt=""
					aria-hidden="true"
				/>
				{text ? (
					<div className="spinner-text">{text}</div>
				) : (
					<span className="visually-hidden">Loading</span>
				)}
			</div>
		</div>
	);
}

export default Spinner;
